import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import createSyarahV2Fetcher from "@/common/fetchSyarahv2";
export var api__me = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(isLoggedIn) {
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (isLoggedIn) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          _context.n = 2;
          return createSyarahV2Fetcher().get("/customer/profile");
        case 2:
          res = _context.v;
          return _context.a(2, res.data.data);
      }
    }, _callee);
  }));
  return function api__me(_x) {
    return _ref.apply(this, arguments);
  };
}();